export default "__VITE_ASSET__o9cBz3Q___"